function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Draggable from '@telerik/kendo-draggable';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
/**
 * @hidden
 */

var GroupingIndicator =
/** @class */
function (_super) {
  __extends(GroupingIndicator, _super);

  function GroupingIndicator() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.element = null;
    _this.draggable = new Draggable({
      press: _this.press,
      drag: _this.drag,
      release: _this.release
    });
    return _this;
  }

  GroupingIndicator.prototype.press = function (event) {
    if (this.element) {
      this.$emit('press', event, this.element);
    }
  };

  GroupingIndicator.prototype.drag = function (event) {
    if (this.element) {
      this.$emit('drag', event, this.element);
    }
  };

  GroupingIndicator.prototype.release = function (event) {
    if (this.element) {
      this.$emit('release', event, this.element);
    }
  };

  GroupingIndicator.prototype.sortChange = function (event) {
    event.preventDefault();
    var sort = this.$props.dir === 'asc' ? 'desc' : 'asc';
    this.$emit('sortChange', event, sort);
  };

  GroupingIndicator.prototype.groupRemove = function (event) {
    event.preventDefault();
    this.$emit('remove', event);
  };

  GroupingIndicator.prototype.mounted = function () {
    this.element = this.$refs.indicatorContainer;

    if (this.element === null) {
      return;
    }

    this.draggable.bindTo(this.element);
  };

  GroupingIndicator.prototype.destroyed = function () {
    this.draggable.destroy();
  }; // @ts-ignore


  GroupingIndicator.prototype.render = function (h) {
    return h("div", {
      "class": "k-indicator-container",
      ref: 'indicatorContainer'
    }, [h("div", {
      "class": "k-group-indicator"
    }, [h("a", {
      "class": "k-link",
      attrs: {
        href: "#",
        tabIndex: -1
      },
      on: {
        "click": this.sortChange
      }
    }, [h("span", {
      "class": 'k-icon k-i-sort-' + this.$props.dir + '-sm'
    }), this.$props.title]), h("a", {
      "class": "k-button k-button-icon k-bare",
      attrs: {
        tabIndex: -1
      },
      on: {
        "click": this.groupRemove
      }
    }, [h("span", {
      "class": "k-icon k-i-group-delete"
    })])])]);
  };

  GroupingIndicator = __decorate([Component({
    props: {
      title: String,
      dir: String // 'asc' | 'desc';

    }
  })], GroupingIndicator);
  return GroupingIndicator;
}(VueComponent);

export { GroupingIndicator };